import React from 'react';
import { Route } from 'react-router-dom';
import { View } from '../../../../../components';
import { view, applet } from './core';

const ResetPassword = React.lazy(() => import('./ResetPassword'));

export default (<Route exact key={view} path={view}>
  <View view={view} applet={applet} component={ResetPassword} />
</Route>);
